import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import Utils from './utils.service'

import apiFetch from '@wordpress/api-fetch'
import FrontPageEnum from '../enumerators/front-page.enum'

export default class HomeService {
    constructor() {
        this.sectionMyProjectSlider()
        this.sectionMyProjectScrollAnimation()
        this.sectionAmbitionsSlider()
        this.sectionActualitiesSlider()
        this.sectionPortraitsSlider()
        this.sectionPortraitsScrollAnimation()
        this.sectionPartnersSlider()
        this.initInstagramWall()
        this.removeHomeAnimationClass() //To avoid navbar animation when page (home page) is on top
        this.customerScrollReveal()
        this.scrollIncitation()
    }

    async sectionMyProjectSlider() {
        if (window.matchMedia('(max-width: 1000px)').matches && !$('.eco-mode-active').length) {
            const publicationsSelector = '.section__my-project__publication'
            $(publicationsSelector).wrapAll(
                '<div class="section__my-project__slider js-section-my-project-slider" />',
            )
            const sliderMyProjectSelector = '.js-section-my-project-slider'

            const options = {
                spaceBetween: 10,
                lazy: true,
            }

            if ($(sliderMyProjectSelector).length) {
                Utils.swiperWrapper(sliderMyProjectSelector)
            }

            await Swiper.create(sliderMyProjectSelector, options)
        }
    }

    sectionMyProjectScrollAnimation() {
        if (
            !$('body.eco-mode-active').length &&
            window.matchMedia('(min-width: 1000.1px)').matches
        ) {
            $(window).on('load resize scroll', () => {
                const scrollTop = $(window).scrollTop()

                const $rightColumn = $('.section__my-project .right-column')
                const $leftColumn = $('.section__my-project .left-column')

                const $section = $('.section__my-project')
                const $text = $('.section__my-project__text')
                const $post2 = $('[data-cx-publication-index="2"]')
                const $post4 = $('[data-cx-publication-index="4"]')
                const $links = $('.section__my-project__links')

                const textHeight = $text.outerHeight()
                const post2Height = $post2.outerHeight()
                const post4Height = $post4.outerHeight()
                const linksHeight = $links.outerHeight()
                const col2Height = textHeight + post2Height + post4Height + linksHeight

                const sectionOffset = $section.offset().top

                const yPosition = (scrollTop - sectionOffset) / 10

                if (scrollTop > sectionOffset && scrollTop < sectionOffset + col2Height) {
                    $rightColumn.css({
                        transform: `translate3d(0, ${yPosition}px, 0)`,
                    })

                    $leftColumn.css({
                        transform: `translate3d(0, -${yPosition}px, 0)`,
                    })
                }
            })
        }
    }

    async sectionAmbitionsSlider() {
        const publicationsSelector = '.js-section-ambitions-slider'
        const options = {
            spaceBetween: 10,
            navigation: {
                nextEl: '.js-section-ambitions-slider-arrow-next',
                prevEl: '.js-section-ambitions-slider-arrow-prev',
            },
            grabCursor: true,
            breakpoints: {
                1000: {
                    spaceBetween: 40,
                },
            },
        }
        if ($(publicationsSelector).length) {
            Utils.swiperWrapper(publicationsSelector)
            await Swiper.create(publicationsSelector, options)

            this.sliderNavigationArrowsPosition(
                '.js-section-ambitions-navigation-arrows',
                '.js-section-ambitions-slider .publication .thumb',
            )
        }
    }

    async sectionActualitiesSlider() {
        const publicationsSelector = '.js-section-actualities-slider'
        const options = {
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: {
                nextEl: '.js-section-actualities-slider-arrow-next',
                prevEl: '.js-section-actualities-slider-arrow-prev',
            },
            grabCursor: true,
            breakpoints: {
                1000: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
            },
        }
        if ($(publicationsSelector).length) {
            Utils.swiperWrapper(publicationsSelector)
            await Swiper.create(publicationsSelector, options)

            this.sliderNavigationArrowsPosition(
                '.js-section-actualities-navigation-arrows',
                '.js-section-actualities-slider .publication .thumb',
            )
        }
    }

    async sectionPortraitsSlider() {
        const hasTouch = 'ontouchstart' in window

        // Content portraits
        const publicationsSelectorContents = '.js-section-portraits-contents-slider'
        const optionsContents = {
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: false,
            mousewheel: false,
            spaceBetween: 10,
            slidesPerView: 1,
            parallax: true,
            navigation: {
                nextEl: '.js-section-portraits-slider-arrow-next',
                prevEl: '.js-section-portraits-slider-arrow-prev',
            },
        }
        let contentsSlider
        if ($(publicationsSelectorContents).length) {
            Utils.swiperWrapper(publicationsSelectorContents)
            contentsSlider = await Swiper.create(publicationsSelectorContents, optionsContents)
        }

        if (window.matchMedia('(max-width: 1000px)').matches && hasTouch) {
            contentsSlider.destroy(true, true)
        }

        // Thumbs part
        const publicationsSelectorThumbs = '.js-section-portraits-thumbs-slider'
        let activeSlideIndex = 0
        const optionsThumbs = {
            slidesPerView: 'auto',
            spaceBetween: 10,
            mousewheel: false,
            navigation: {
                nextEl: '.js-section-portraits-slider-arrow-next',
                prevEl: '.js-section-portraits-slider-arrow-prev',
            },
            breakpoints: {
                1000: {
                    spaceBetween: 40,
                },
            },
            on: {
                slideChange: (swiper) => {
                    activeSlideIndex = swiper.activeIndex
                },
                slideChangeTransitionStart: (swiper) => {
                    if (!window.matchMedia('(max-width: 1000px)').matches) {
                        contentsSlider.slideTo(activeSlideIndex)
                    }
                },
            },
        }

        if ($(publicationsSelectorThumbs).length) {
            Utils.swiperWrapper(publicationsSelectorThumbs)
            await Swiper.create(publicationsSelectorThumbs, optionsThumbs)
        }
    }

    sectionPortraitsScrollAnimation() {
        if (
            !$('body.eco-mode-active').length &&
            window.matchMedia('(min-width: 1000.1px)').matches
        ) {
            $(window).on('load resize scroll', () => {
                const scrollTop = $(window).scrollTop()

                const $rightColumn = $('.section__portraits .right-column')
                const $leftColumn = $('.section__portraits .left-column')

                const $section = $('.section__portraits')

                const sectionOffset = $section.offset().top

                const yPosition = (scrollTop - sectionOffset) / 10

                const col2Height = $rightColumn.outerHeight()

                if (scrollTop > sectionOffset && scrollTop < sectionOffset + col2Height) {
                    $rightColumn.css({
                        transform: `translate3d(0, ${yPosition}px, 0)`,
                    })

                    $leftColumn.css({
                        transform: `translate3d(0, -${yPosition}px, 0)`,
                    })
                }
            })
        }
    }

    sliderNavigationArrowsPosition(arrowsSelector, thumbSelector) {
        const $navigationsArrowsSelector = $(`${arrowsSelector}`)
        const $publicationThumbSelector = $(`${thumbSelector}`)

        if ($navigationsArrowsSelector.length && $publicationThumbSelector.length) {
            let arrowsHeight = $navigationsArrowsSelector.outerHeight()
            let publicationThumbHeight = $publicationThumbSelector.outerHeight()

            $(window).on('resize', () => {
                arrowsHeight = $navigationsArrowsSelector.outerHeight()
                publicationThumbHeight = $publicationThumbSelector.outerHeight()

                $navigationsArrowsSelector.css({
                    top: publicationThumbHeight - arrowsHeight,
                })
            })

            $navigationsArrowsSelector.css({
                top: publicationThumbHeight - arrowsHeight,
            })
        }
    }

    async sectionPartnersSlider() {
        if (window.matchMedia('(max-width: 1000px)').matches) {
            const publicationsSelector = '.js-section-partners-slider'
            const options = {
                spaceBetween: 10,
                lazy: true,
            }

            if ($(publicationsSelector).length) {
                Utils.swiperWrapper(publicationsSelector)
                await Swiper.create(publicationsSelector, options)
            }
        }
    }

    initInstagramWall() {
        const $selector = $(FrontPageEnum.STRATE_SOCIAL_WALL)

        /* Strate social wall --------------------- */
        if ($selector.length > 0 && !$selector.is(':hidden')) {
            apiFetch({
                path: IRISCollectionCustomer.irisSsoInstagramPath,
                method: 'POST',
                data: { limit: 4 },
            })
                .then((result) => {
                    $selector.html(result.render)
                    import(
                        '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                    ).then(({ HcLazyload }) => {
                        HcLazyload.update()
                    })
                })
                .catch(() => {
                    $selector.html(IRISCollectionCustomer.irisSsoInstagramError)
                })
        }
    }

    removeHomeAnimationClass() {
        if (!$('body.eco-mode-active').length) {
            setTimeout(() => {
                $('body.home-header-will-animate').removeClass('home-header-will-animate')
            }, 3000)
        }
    }

    customerScrollReveal() {
        if (
            !$('body.eco-mode-active').length &&
            window.matchMedia('(min-width: 1000.1px)').matches
        ) {
            const ratio = 0.3
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.3,
            }

            const handleIntersect = (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio >= ratio) {
                        entry.target.classList.remove('reveal')
                        observer.unobserve(entry.target)
                    }
                })
            }

            document.documentElement.classList.add('reveal-loaded')
            const observer = new IntersectionObserver(handleIntersect, options)
            document.querySelectorAll('.reveal').forEach((el) => {
                observer.observe(el)
            })
        } else {
            for (let i = 1; i <= 20; i++) {
                document.querySelectorAll(`.reveal-${i}`).forEach((el) => {
                    el.classList.remove(`reveal-${i}`)
                })
            }
        }
    }

    scrollIncitation() {
        const $scrollButton = $('body.home .js-scroll-incitation')
        if ($scrollButton.length)
            $scrollButton.on('click', () => {
                // $(".header").animate({ scrollTop: $('.header').prop("scrollHeight")}, 1000);
                $('html, body').animate(
                    {
                        scrollTop: $('.header').height(),
                    },
                    1000,
                )
            })
    }
}
